<form class="mce-form-section">

    @if(viewState().required) {

    <div class="mce-form-section-title">EFL (Earth Fault Loop)</div>

    <div class="mce-form-field-group flex-2-1 border border-solid p-4">

        <div class="flex flex-1 flex-col">

            <div class="mce-form-field-group">
                @if(form().earthFaultLoop.userIa().value()) {
                <div>
                    <mat-form-field>
                        <mat-label>Ia</mat-label>
                        <input matInput type="number" placeholder="Ia"
                               [formField]="form().earthFaultLoop.userIaValue" />
                        <span matSuffix>A</span>
                        @for (error of form().earthFaultLoop.userIaValue().errors(); track error.kind ) {
                        <mat-error> {{ error.message }} </mat-error> }
                    </mat-form-field>
                </div>
                }
                <div>
                    <mat-checkbox [formField]="form().earthFaultLoop.userIa">
                        Override Ia
                    </mat-checkbox>
                </div>
            </div>


            <div class="mce-form-field-group">
                @if(form().earthFaultLoop.userZs().value()) {
                <div>
                    <mat-form-field>
                        <mat-label>Zs</mat-label>
                        <input matInput type="number" placeholder="Zs"
                               [formField]="form().earthFaultLoop.userZsValue" />
                        <span matSuffix>Ω</span>
                        @for (error of form().earthFaultLoop.userZsValue().errors(); track error.kind ) {
                        <mat-error> {{ error.message }} </mat-error> }
                    </mat-form-field>
                </div>
                }
                <div>
                    <mat-checkbox [formField]="form().earthFaultLoop.userZs">
                        Override Zs
                    </mat-checkbox>
                </div>
            </div>

            <div class="mce-form-field-group">
                @if(form().earthFaultLoop.userMaxDisconnectionTime().value()){
                <div>
                    <mat-form-field>
                        <mat-label>max. disconnection time </mat-label>
                        <input matInput type="number" placeholder="max. disconnection time"
                               [formField]="form().earthFaultLoop.userMaxDisconnectionTimeValue" />
                        <span matSuffix>s</span>
                        @for (error of form().earthFaultLoop.userMaxDisconnectionTimeValue().errors(); track error.kind ) {
                        <mat-error> {{ error.message }} </mat-error> }
                    </mat-form-field>
                </div>
                }
                <div>
                    <mat-checkbox [formField]="form().earthFaultLoop.userMaxDisconnectionTime">
                        Override Max. Disconnection Time
                    </mat-checkbox>
                </div>
            </div>

        </div>

        <div class="w-64 flex-none">
            <mce-info-message [type]="'information'">
                EFL values are typically calculated. These can be overriden if requried.
            </mce-info-message>
        </div>

    </div>


    <app-calculation-box [status]="viewState().status" [loading]="viewState().isLoading">

        <div class="calculation-box-content">
            @if(viewState().showEFLCalculation) {
            <div>
                EFL Zs: {{viewState().zs}} [max: {{viewState().maxZs}}, {{viewState().t}}]
            </div>
            }
        </div>

        @if(!viewState().showEFLCalculation) {
        <div>Enter all required fields to calculate EFL.</div>
        }

    </app-calculation-box>

    }



</form>
